import React, { Component } from 'react';
import dedent from 'dedent';
import emailService from 'services/email';

import SidebarContainer from 'containers/SidebarContainer';

import PageHeader from 'components/PageHeader';
import Footer from 'components/Footer';
import TitleWithShape from 'components/TitleWithShape';
import InputField from 'components/InputField';
import TextArea from 'components/TextArea';
import RectButton from 'components/RectButton';
import PhoneNumber from 'components/PhoneNumber';

import EmailIcon from 'assets/images/icons/email.svg';
import PhoneIcon from 'assets/images/icons/phone.svg';

import Wrapper from './Wrapper';

class ContactPage extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      isVisible: false,
      limit: 2000,
      name: '',
      phone: '',
      showFailed: false,
      showSuccessful: false,
      submitted: false,
      question: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChangeTextarea = (e) => {
    this.setState({
      limit: 2000 - e.target.value.length,
      question: e.target.value,
    });
  }

  onChange = (e, key) => {
    this.setState({ [key]: e.target.value });
  }

  onSubmitForm = () => {
    this.setState({ submitted: true });
    const message = dedent`
      Name: ${this.state.name}
      Email: ${this.state.email}
      Phone: ${this.state.phone}
      Message:
      ${this.state.question}
    `;

    emailService.contact(message);
    fetch(`${process.env.REACT_APP_API_ENDPOINT}/email`, {
      method: 'POST',
      body: JSON.stringify(emailService),
    }).then((res) => {
      if (res.ok) {
        this.setState({ showSuccessful: true });
        // Confirmation email to user
        emailService.contactConfirmation(this.state.email, this.state.question);
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/email`, {
          method: 'POST',
          body: JSON.stringify(emailService),
        });
      } else {
        this.setState({ showFailed: true });
      }
    });
  }

  handleSidebar = () => {
    this.setState({ isVisible: !this.state.isVisible });
  }

  validate = () => {
    const {
      email,
      limit,
      name,
      phone,
    } = this.state;
    const valid = (email !== '' && name !== '' && limit >= 0 && limit !== 2000 && phone !== '');
    return !valid;
  }

  render() {
    const {
      isVisible,
      email,
      limit,
      name,
      phone,
      showFailed,
      showSuccessful,
      submitted,
      question,
    } = this.state;

    return (
      <SidebarContainer
        visible={isVisible}
        page="contact"
      >
        <Wrapper>
          <PageHeader page="contact" handleSidebar={this.handleSidebar} />
          <div className="content">
            <div className="left-pane">
              <TitleWithShape title="Contact us" />
              <div className="fields">
                <InputField
                  placeholder="Name"
                  name="name"
                  onChange={this.onChange}
                  value={name}
                  isRequired
                />
                <InputField
                  placeholder="Email"
                  name="email"
                  onChange={this.onChange}
                  value={email}
                  isRequired
                />
                <InputField
                  placeholder="Phone"
                  name="phone"
                  onChange={this.onChange}
                  value={phone}
                  isRequired
                />
                <div className="description">
                  <TextArea
                    placeholder="Please type your message here..."
                    onChange={this.onChangeTextarea}
                    cols="50"
                    limit={limit}
                    value={question}
                  />
                </div>
              </div>
              <div className="button-wrapper">
                {submitted
                  ? (
                    <RectButton
                      color="#8AEBF1"
                      title="Submitted"
                      width={20}
                      disabled
                    />)
                  : (
                    <RectButton
                      color="#8AEBF1"
                      title="Submit"
                      width={20}
                      onClick={() => this.onSubmitForm()}
                      disabled={this.validate()}
                    />)
                }

              </div>
              {showFailed && <p className="response">Something went wrong. Please try again later or contact us directly.</p>}
              {showSuccessful && <p className="response">Your contact form has been submitted. We will be in contact with you shortly.</p>}
            </div>
            <div className="right-pane">
              <div>
                <h1>Contact info</h1>
                <div className="info">
                  <img alt="phone" src={PhoneIcon} />
                  <div>
                    <PhoneNumber color="#35447d" />
                  </div>
                </div>
                <div className="info">
                  <img alt="email" src={EmailIcon} />
                  <div>
                    <p>qlegal@jmlrose.com.au</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </Wrapper>
      </SidebarContainer>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/containers/ContactPage/index.js